import React from "react";
import { useMediaQuery } from 'react-responsive'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import logo from './Assets/Images/dream4IconLogo.png';
import './App.css';

//theme
import "./Assets/Styles/theme-primereact.css"; 

//core
import "primereact/resources/primereact.min.css";

//icons
import "primeicons/primeicons.css";  

import DesktopLayout from './Layouts/Desktop';
import MobileLayout from './Layouts/Mobile';

import ReCAPTCHA from "react-google-recaptcha"
import * as Config from './Config/api';

function App() {

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)'
  })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })	
	
  const recaptchaRef = React.useRef(null);
	
  return (
    <div className="App">
		<div>
			{isDesktopOrLaptop && <DesktopLayout />}
			{isTabletOrMobile && <MobileLayout />}
		</div>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
		    badge="bottomleft" /*inline*/
        sitekey={Config.REACT_APP_SITE_KEY}
      />		

      <FloatingWhatsApp
        phoneNumber="+552139550574"
        accountName="Suporte Dream4"
        allowClickAway={true}
        chatMessage="Olá! Caso tenha dúvidas sobre cadastro ou reserva, fale conosco via whatsapp!"
        statusMessage="Fale conosco quando precisar"
        placeholder="Digite sua mensagem aqui..."
        avatar={logo}
        notification={true}
        notificationSound={true}
        notificationDelay={5000}        
        chatboxStyle={{ width: '450px', height: '300px' }}
        style={{ bottom: '5rem', right: '20px' }}
        buttonStyle={{ bottom:"6rem" }}
       />

    </div>
  );
}

export default App;
